import React, { useEffect, useState } from "react"
import ReactModal from "react-modal"
import "../../Styles/Homestyle.css"
import { FaFacebook, FaInstagram } from "react-icons/fa"
import { FaTiktok } from "react-icons/fa6"
import Logo from "../images/Logo.png"
import Hands from "../images/HomeImage.png"
import { motion as m, AnimatePresence } from "framer-motion"
import { Link } from "react-router-dom"
import { db, rtdb } from "../../Firebase/config"
import { ref, update, remove, onValue, get } from "firebase/database"
import DOMPurify from "dompurify"
import usefetchdocument from "../Componentslogic/Usefetchdocument"
import { doc, updateDoc, getDoc } from "firebase/firestore"
import Notify from "../Componentslogic/Usenotifications"
import Ratingcomponent from "../Thankyou/Starrate"
import { CLEAR_CART } from "../../redux/actions/CartSlice"
import { useDispatch } from "react-redux"
import axios from "axios"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
ReactModal.setAppElement("#root")

function HomePage() {
  const dispatch = useDispatch()
  const [hasActiveDeliveryOrder, setHasActiveDeliveryOrder] = useState(false)
  const [showOrderReadyModal, setShowOrderReadyModal] = useState(false)
  const [showNotification, setShowNotification] = useState(false)
  const [showReviewModal, setShowReviewModal] = useState(false)
  const [currentOrderID, setCurrentOrderID] = useState(null)
  const [orderStatus, setOrderStatus] = useState(null)
  const [showPendingOrderModal, setShowPendingOrderModal] = useState(false)
  const [orderDetails, setOrderDetails] = useState(null)
  const [progressWidth, setProgressWidth] = useState("0%") // Progress bar width
  const [progressColor, setProgressColor] = useState("#f4c542") // Initial color
  const [orderItems, setOrderItems] = useState([]) // Stores the cart items
  const [selectedOfferIndex, setSelectedOfferIndex] = useState(0)
  const [showOrderSummary, setShowOrderSummary] = useState(false)
  const { document: Notification } = usefetchdocument(
    "Notification",
    "4Az1NF5LIxQWdsCwmfXb"
  )

  const NotificationSanitize = Notification
    ? Notification.Notification !== ""
      ? DOMPurify.sanitize(Notification.Notification)
      : ""
    : ""

  useEffect(() => {
    const orderID = localStorage.getItem("orderID")

    if (orderID) {
      const orderRTDBRef = ref(rtdb, `orders/${orderID}`)

      const unsubscribeRTDB = onValue(orderRTDBRef, (snapshot) => {
        if (snapshot.exists()) {
          const orderData = snapshot.val()
          updateOrderStatus(orderData) // ✅ Update order state
          setOrderDetails({
            ordernumber: orderData.ordernumber || "Unknown",
            totalAmount: orderData.totalAmount || "0",
          })
        } else {
          localStorage.removeItem("orderID")
          localStorage.removeItem("waiterRequested")
          setOrderStatus(null)
          setOrderDetails(null)
        }
      })

      return () => {
        unsubscribeRTDB()
      }
    }
  }, [])

  const updateOrderStatus = (orderData) => {
    if (orderData.Done) {
      setOrderStatus("Done")
      setProgressWidth("100%")
      setProgressColor("#28a745")
      setShowOrderReadyModal(true)
    } else if (orderData.Checked) {
      setOrderStatus("Preparing")
      setProgressWidth("50%")
      setProgressColor("#ff7f00") // Orange
    } else if (orderData.Confirmed) {
      setOrderStatus("Preparing")
      setProgressWidth("0%")
      setProgressColor("#f4c542") // Yellow
    } else {
      setOrderStatus("Pending")

      setShowPendingOrderModal(true)
    }

    // 🔹 Store cart items
    if (orderData.cartItems) {
      setOrderItems(orderData)
    }
  }

  const getUserFromLocalStorage = () => {
    try {
      const userData = localStorage.getItem("user")
      if (!userData) return null
      return JSON.parse(userData)
    } catch (error) {
      localStorage.removeItem("user")
      return null
    }
  }

  const user = getUserFromLocalStorage()

  useEffect(() => {
    if (Notification) {
      setShowNotification(true)
      setTimeout(() => {
        setShowNotification(false)
      }, 5000)
    }
  }, [Notification])

  return (
    <div className="container-home">
      <AnimatePresence>
        {showNotification && localStorage.getItem("orderID") === null && (
          <m.div
            className="top-notification"
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            exit={{ y: -200 }}
            transition={{ duration: 0.5 }}
          >
            <div className="notification-content">
              <div className="text notification-wrapper">
                <h4>
                  <b>Welcome to FireyNash!</b>
                </h4>
              </div>

              <div className="desc-title">
                {Notification && Notification.Notification.trim() !== "" ? (
                  <p
                    dangerouslySetInnerHTML={{ __html: NotificationSanitize }}
                  />
                ) : (
                  <p className="p-0 m-0">
                    <b> A TASTE YOU CAN SEE!</b>
                  </p>
                )}
              </div>
            </div>
          </m.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {/* 🔥 Top Banner for Pending Orders */}
        {orderStatus === "Pending" && orderDetails && (
          <m.div
            className="top-notification pending-order-banner"
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            exit={{ y: -200 }}
            transition={{ duration: 0.5 }}
          >
            <div className="notification-content">
              <h4 className="text" style={{ color: "black" }}>
                Order: # {orderDetails.ordernumber}{" "}
              </h4>

              <p className="text">
                {" "}
                Please pay at the cashier so that your order starts preparing
              </p>
            </div>
          </m.div>
        )}
      </AnimatePresence>

      {/* 🔥 Cool Order Ready Modal */}
      <ReactModal
        isOpen={showOrderReadyModal}
        onRequestClose={() => setShowOrderReadyModal(false)}
        className="order-ready-modal"
        overlayClassName="modal-overlay"
      >
        <div className="modal-content">
          <h2 className="modal-title">Hey {user?.name},</h2>
          <h2 className="modal-title">
            Your Order # {orderItems.ordernumber} is Ready!
          </h2>

          <button
            className="confirm-button"
            onClick={() => setShowOrderReadyModal(false)}
          >
            Got It! 👍
          </button>
        </div>
      </ReactModal>

      {/* Review Modal */}
      <ReactModal
        isOpen={showReviewModal}
        onRequestClose={() => setShowReviewModal(false)}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">We Value Your Feedback</h2>
        <Ratingcomponent
          orderID={currentOrderID}
          closeModal={() => setShowReviewModal(false)}
        />{" "}
        {/* Embed Ratingcomponent */}
        <div
          onClick={() => setShowReviewModal(false)}
          className="d-flex justify-content-center  skip"
        >
          <p>Skip</p>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={showOrderSummary}
        onRequestClose={() => setShowOrderSummary(false)}
        className="modal-content-summ"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Order Summary</h2>
        <p className="modal-title">Order: # {orderItems?.ordernumber}</p>

        {orderItems?.cartItems?.length > 0 ? (
          <div className="order-summary">
            {orderItems.cartItems.map((item, index) => {
              // 🔥 Calculate extra costs
              const basePrice = item.Price || 0
              const comboPrice = item.combo?.Price || 0

              const spicePrice = item.spiceLevel === "Spicy 3" ? 5 : 0

              // 🔥 Calculate final item price per quantity
              const totalItemPrice =
                (basePrice + comboPrice + spicePrice) * item.CartTotalQuantity

              return (
                <div className="cart-item" key={index}>
                  {/* Item Name and Quantity */}
                  <div className="cart-item-header">
                    <p className="cart-item-name">
                      {item.name} x{item.CartTotalQuantity}{" "}
                    </p>
                  </div>

                  {item.spiceLevel && (
                    <p className="cart-item-detail">
                      <b>{item.spiceLevel}</b>
                    </p>
                  )}
                  {item.selectedSize && (
                    <p className="cart-item-detail">
                      <b>{item.selectedSize}</b>
                    </p>
                  )}
                  {item.combo && item.combo.name && (
                    <p className="cart-item-detail">
                      <b>- {item.combo.name || "Selected Combo"}</b>
                    </p>
                  )}
                  {item.freeSauce && (
                    <p className="cart-item-detail">
                      <b>{item.freeSauce}</b>
                    </p>
                  )}

                  {/* 🔥 Price Calculation */}
                  <p className="cart-item-price">{totalItemPrice.toFixed(2)}</p>
                </div>
              )
            })}
          </div>
        ) : (
          <p className="empty-cart">No items in your order.</p>
        )}
        <div className="d-flex justify-content-center">
          <button
            className="confirm-button "
            onClick={() => setShowOrderSummary(false)}
          >
            Close
          </button>
        </div>
      </ReactModal>

      <m.div
        className="Text-home"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.3 }}
        exit={{ opacity: 1 }}
      >
        <div className="d-flex justify-content-center flex-column">
          <img
            className={` ${
              localStorage.getItem("orderID") ? "small-logo" : "images-Hands"
            }`}
            alt="Logo"
            src={Logo}
          />
        </div>

        {localStorage.getItem("orderID") == null && (
          <div class="taste-banner">A TASTE YOU CAN SEE</div>
        )}

        {localStorage.getItem("orderID") !== null ? (
          <div className="d-flex flex-column justify-content-center align-items-center">
            <p
              className="order-summary-btn"
              onClick={() => setShowOrderSummary(true)}
            >
              Order Summary
            </p>

            <AnimatePresence>
              <div className="step-progress-container">
                <div className="step">
                  <div
                    className={`step-circle ${
                      orderStatus === "Pending" ||
                      orderStatus === "Confirmed" ||
                      orderStatus === "Preparing" ||
                      orderStatus === "Done"
                        ? "active"
                        : ""
                    }`}
                  >
                    1
                  </div>
                  <p className="step-label">Pay at Cashier</p>
                </div>

                <div className="step-line"></div>
                <div className="step">
                  <div
                    className={`step-circle ${
                      orderStatus === "Preparing" || orderStatus === "Done"
                        ? "active"
                        : ""
                    }`}
                  >
                    2
                  </div>
                  <p className="step-label">Preparing</p>
                </div>
                <div className="step-line me-4"></div>
                <div className="step">
                  <div
                    className={`step-circle ${
                      orderStatus === "Done" ? "active" : ""
                    }`}
                  >
                    3
                  </div>
                  <p className="step-label">Done</p>
                </div>
              </div>
            </AnimatePresence>
            {orderStatus === "Pending" && (
              <Link to="/Menu" style={{ textDecoration: "none" }}>
                <button
                  className="button mt-3 mb-2"
                  onClick={() => localStorage.removeItem("waiterRequested")}
                >
                  <p className="p-1 m-0"> Add to Order</p>
                </button>
              </Link>
            )}

            {orderStatus === "Done" && (
              <button
                className="button-req mt-3"
                onClick={() => {
                  setShowReviewModal(true)
                  localStorage.removeItem("orderID")
                  localStorage.removeItem("waiterRequested")
                  localStorage.setItem("Cartproducts", [])
                  dispatch(CLEAR_CART())
                }}
              >
                <p className="p-0 m-0">Review Your Order!</p>
              </button>
            )}
          </div>
        ) : (
          <div className="d-flex flex-column justify-content-center">
            <Link to="/Menu" style={{ textDecoration: "none" }}>
              <button className="button mt-3 mb-5">
                <p className="p-1 m-0"> Browse Menu</p>
              </button>
            </Link>
          </div>
        )}
        <div className="d-flex flex-column">
          <p className="social-text">
            <b>Follow Us for Updates & Offers!</b>
          </p>
          <div className="social-icons-container">
            <a
              href="https://www.facebook.com/profile.php?id=61569864055209"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-wrapper"
            >
              <FaFacebook className="social-icon facebook-icon" />
            </a>
            <a
              href="https://www.tiktok.com/@fireynash?_t=ZS-8tt2VE2HSCa&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-wrapper"
            >
              <FaTiktok className="social-icon " />
            </a>
            <a
              href="https://www.instagram.com/firey_nash/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-wrapper"
            >
              <FaInstagram className="social-icon instagram-icon" />
            </a>
          </div>
        </div>
      </m.div>
    </div>
  )
}

export default HomePage
